import { RoleDto } from './RoleDto';
import { PermissionDto } from './PermissionDto';

export class GetRolesForApplicationDto {
  roles: Array<RoleDto>;
  permissions: Array<PermissionDto>;
}
